import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const PDFIcon = ({ color = '#B5BCBD', size = '40', ...props }) => (
  <svg
    viewBox="0 0 24 29"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.531.5c.417 0 .834.162 1.148.424l.112.103 6.652 6.652c.308.308.481.683.54 1.086L24 8.94v17.64c0 .947-.74 1.708-1.644 1.782l-.144.006H1.788c-.947 0-1.708-.74-1.782-1.644L0 26.581V2.288C0 1.34.74.58 1.644.506L1.788.5H15.53zm-.703 2.051H2.05v23.912l19.898.03V9.672h-5.334c-.946 0-1.708-.741-1.781-1.645l-.006-.143V2.55zm-3.181 3.95c.44.005.72.193.89.377.679.736.407 2.302-.338 4.7.727 1.705 1.808 3.557 2.922 4.89a9.817 9.817 0 0 1 1.407-.149c1.34-.038 2.41.254 3.012.823.424.401.566.918.38 1.384-.252.63-1.026.992-2.123.992-1.01 0-2.084-.7-3.1-1.764-.88.205-1.925.554-3.154 1.12-.778.359-1.466.705-2.073 1.036-.718 2.005-1.523 3.412-3.229 4.263-.484.241-.865.327-1.163.327a1.15 1.15 0 0 1-.658-.185c-.296-.2-.447-.536-.416-.924.077-.953 1.34-2.504 4.5-4.294.183-.542.37-1.14.575-1.8l.307-.98.165-.518.22-.668c.15-.451.306-.91.46-1.36.243-.716.491-1.444.714-2.14-.414-1.045-.694-2.016-.788-2.777-.213-1.725.532-2.176.995-2.291.184-.046.348-.065.495-.063zM7.779 20.922c-1.698 1.128-2.36 1.979-2.542 2.376.109-.025.265-.076.476-.18.959-.48 1.565-1.183 2.066-2.196zm9.06-3.426h-.22c-.151.003-.313.01-.484.024.589.511 1.159.818 1.662.818.676 0 .95-.168 1.014-.237-.026-.05-.122-.171-.374-.297-.153-.076-.6-.26-1.392-.3l-.206-.008zm-5.179-4.264-.31.918c-.153.446-.308.903-.457 1.35l-.217.66-.164.513-.304.973c-.07.224-.138.443-.206.656.333-.165.681-.332 1.046-.5a18.795 18.795 0 0 1 2.796-1.042c-.82-1.051-1.573-2.293-2.184-3.528zm.008-5.555h-.03a.822.822 0 0 0-.199.029c-.07.018-.196.294-.109 1.002.035.285.1.598.187.933.388-1.623.173-1.938.151-1.964zm5.211-3.662v3.605h3.605l-3.605-3.605z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

PDFIcon.propTypes = propTypes;

export default PDFIcon;
